import { render, staticRenderFns } from "./ApiDocumentation.vue?vue&type=template&id=f9c0de50&scoped=true&"
import script from "./ApiDocumentation.vue?vue&type=script&lang=js&"
export * from "./ApiDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ApiDocumentation.vue?vue&type=style&index=0&id=f9c0de50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c0de50",
  null
  
)

export default component.exports